/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ naam: NonNullable<unknown> }} Planning_Rooster_Pauze_Verwijderen_NaamInputs */

const nl_planning_rooster_pauze_verwijderen_naam = /** @type {(inputs: Planning_Rooster_Pauze_Verwijderen_NaamInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.naam} verwijderen`)
};

/**

* @param {Planning_Rooster_Pauze_Verwijderen_NaamInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_rooster_pauze_verwijderen_naam = /** @type {((inputs: Planning_Rooster_Pauze_Verwijderen_NaamInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Rooster_Pauze_Verwijderen_NaamInputs, { locale?: "nl" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_rooster_pauze_verwijderen_naam(inputs)
});
export { planning_rooster_pauze_verwijderen_naam as "planning.rooster.pauze_verwijderen_naam" }